export default __webpack_public_path__ + "static/media/Copy of Phishing.226cefe1.jpg";